import { callFetch, header } from "./utils";

const EndPoint = {
  GetStores: (lineId) => `/line/${lineId}/branch?page=1&size=100`,
};

export function getStores(lineId) {
  const uri = EndPoint.GetStores(lineId);
  let settings = {
    method: "GET",
    headers: header,
  };

  return callFetch(uri, settings);
}
